import React, { Component } from 'react';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import Upload from '../../upload/Upload';
import BmcButton from '../bmc-button/Bmc-Button';
import InfoDialog from '../info-dialog/InfoDialog';

import './LandingPage.scss';

export default class LandingPage extends Component {
    constructor(props) {
        super(props);

        this.handler = this.handler.bind(this);
        this.state = {
            fileUploaded: false
        };
    }

    handler(data) {
        this.setState({
            fileUploaded: true
        });
        this.props.uploadDataAvailable(data);
    }

    render() {
        return (
            <div className="Landing-Page">
                <header className="text-right w-100 pt-3 mr-4">
                    {false ? (
                        <BmcButton />
                    ) : null}
                </header>

                <div>
                    <div className="text-white text-center mb-3">
                        <h2>How much are you spending on Amazon?</h2>
                        <p>Get better insights on your orders and see how much you're really spending</p>
                    </div>

                    <Card className="Upload-Card" elevation={15}>
                        <CardContent>
                            <div className="Card">
                                <Upload fileAdded={this.handler} />

                                <small>
                                    <a href="https://www.amazon.com/gp/b2b/reports"
                                        target="_blank" rel="noopener noreferrer">Generate your order history</a>
                                </small>
                                <br />
                                <small>
                                    Currently only the <i>Items</i> report type is supported.
                                </small>
                            </div>

                            <InfoDialog />
                        </CardContent>
                    </Card>
                </div>
                <footer className="text-right">
                </footer>
            </div>
        )
    }
}
